import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';

import { sanitizeURL } from '../../../../utils';
import Link from '../../../Core/Link';
import TextWithIcon from '../../TextWithIcon';

import { StyledContainer, Wrapper, Collection } from './styles';

const FAQCategoryCollection = ({ faqCategory, activeCategory }) => {
  const { category, imageDam, faqSubCategoryItems } = faqCategory[0];

  return (
    <StyledContainer>
      <Wrapper>
        <TextWithIcon
          type="faq-card"
          icon={imageDam.asset.localImage.publicURL}
        >
          <strong>{category}</strong>
        </TextWithIcon>
        <Collection className="no-bullets">
          {faqSubCategoryItems.map(({ id, subCatPageSlug, subCategory }) => {
            return sanitizeURL(subCatPageSlug) ===
              sanitizeURL(activeCategory) ? (
              <li key={id}>
                <p>{ReactHtmlParser(subCategory)}</p>
              </li>
            ) : (
              <li key={id}>
                <Link to={`/learning-hub/faqs/${sanitizeURL(subCatPageSlug)}`}>
                  {ReactHtmlParser(subCategory)}
                </Link>
              </li>
            );
          })}
        </Collection>
      </Wrapper>
    </StyledContainer>
  );
};

FAQCategoryCollection.propTypes = {
  activeCategory: PropTypes.string.isRequired,
  faqCategory: PropTypes.arrayOf(PropTypes.shape()).isRequired,
};

export default FAQCategoryCollection;
